/** Запросы к серверу кабинета: кука сессии и заголовок против подделки запроса. */
export class ApiError extends Error { constructor(message: string, readonly status: number) { super(message); } }
export async function api<T>(path: string, method = "GET", body?: unknown): Promise<T> {
  let response: Response;
  try {
    response = await fetch(`/api/workspace${path}`, { method, credentials: "same-origin", cache: "no-store",
      headers: method === "GET" ? {} : { "Content-Type": "application/json", "X-Egel-Workspace": "1" },
      body: body === undefined ? undefined : JSON.stringify(body), signal: AbortSignal.timeout(20000) });
  } catch { throw new Error("Нет связи с сервером кабинета. Правки остаются в этом браузере. Повторите сохранение после восстановления связи."); }
  const data = await response.json().catch(() => null);
  if (!response.ok || !data) throw new ApiError(data?.error || "Сервер кабинета недоступен", response.status);
  return data as T;
}
